export default __webpack_public_path__ + "static/media/public-24px (1).bc639514.svg";